import styled from 'styled-components/macro';

export const Link = styled.a`
  text-decoration: none;
`;
export const ItemBox = styled('div')<any>`
  background-color: #fff;
  border: 2px solid transparent;
  font-size: 1em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${({ isLargeScreen }): string => (isLargeScreen ? '225px' : '150px')};
  height: ${({ isLargeScreen }): string => (isLargeScreen ? '125px' : '100px')};
  border-radius: 10px;
  flex-flow: column;
  transition: border-color 75ms ease-in-out, background-color 75ms ease-in-out;
  &:hover {
    border-color: ${({ theme }): string => theme.AccentGreen};
    background-color: ${({ theme }): string => theme.LightGrey};
  }
`;

export const SpanBold = styled.span`
  font-weight: 700;
  color: ${({ theme }): string => theme.LightNightBlue};
`;
